import i18n from 'src/i18n';
import moment from 'moment';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'updated_at',
      label: i18n.t('audit.audit_date'),
      sortable: true,
      formatter: (row) =>
        `${moment(row.updated_at).format('YYYY-MM-DD HH:mm:ss')}`,
    },
    {
      prop: 'user.fullname',
      label: i18n.t('audit.operation_user'),
    },
    {
      prop: 'operation_type',
      label: i18n.t('audit.operation_type'),
    },
    {
      prop: 'affectation_module',
      label: i18n.t('audit.module'),
    },
  ];

  return { tableColumns };
};

export default configTable;
